'use client';

import { LogOut } from 'lucide-react';
import { logOut } from 'shared/lib/auth/actions';
import { Button } from 'shared/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'shared/ui/dropdown-menu';
import * as m from '@paraglide/messages';
interface UserMenuProps {
  userName: string | undefined;
}
export const UserMenu = ({
  userName
}: UserMenuProps) => {
  const handleLogout = async () => {
    try {
      await logOut();
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
  return <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="UserMenu" data-sentry-source-file="user-menu.tsx">
      <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="user-menu.tsx">
        <Button variant="ghost" size="sm" className="text-title3" data-sentry-element="Button" data-sentry-source-file="user-menu.tsx">
          {userName}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-40" data-sentry-element="DropdownMenuContent" data-sentry-source-file="user-menu.tsx">
        {/* <DropdownMenuLabel>Мой аккаунт</DropdownMenuLabel> */}
        {/* <DropdownMenuSeparator /> */}
        {/* <DropdownMenuGroup> */}
        {/*  <DropdownMenuItem asChild className="hover:cursor-pointer"> */}
        {/*    <Link href={profileLink as string}> */}
        {/*      <User className="size-4" /> */}
        {/*      <span>Профиль</span> */}
        {/*    </Link> */}
        {/*  </DropdownMenuItem> */}
        {/* </DropdownMenuGroup> */}
        {/* <DropdownMenuSeparator /> */}
        <DropdownMenuItem onClick={handleLogout} className="hover:cursor-pointer" data-sentry-element="DropdownMenuItem" data-sentry-source-file="user-menu.tsx">
          <LogOut className="size-4" data-sentry-element="LogOut" data-sentry-source-file="user-menu.tsx" />
          <span>{m.header_user_exit()}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>;
};